export default {
  wishList: [
    {
      img: require('@/assets/wish/1.png'),
      id: 1
    },
    {
      img: require('@/assets/wish/2.png'),
      id: 2
    },
    {
      img: require('@/assets/wish/3.png'),
      id: 3
    },
    {
      img: require('@/assets/wish/4.png'),
      id: 4
    },
    {
      img: require('@/assets/wish/5.png'),
      id: 5
    },
    {
      img: require('@/assets/wish/6.png'),
      id: 6
    },
    {
      img: require('@/assets/wish/7.png'),
      id: 7
    },
    {
      img: require('@/assets/wish/8.png'),
      id: 8
    },
    {
      img: require('@/assets/wish/9.png'),
      id: 9
    },
    {
      img: require('@/assets/wish/10.png'),
      id: 10
    },
    {
      img: require('@/assets/wish/11.png'),
      id: 11
    },
    {
      img: require('@/assets/wish/12.png'),
      id: 12
    },
    {
      img: require('@/assets/wish/13.png'),
      id: 13
    },
    {
      img: require('@/assets/wish/14.png'),
      id: 14
    },
    {
      img: require('@/assets/wish/15.png'),
      id: 15
    },
    {
      img: require('@/assets/wish/16.png'),
      id: 16
    },
    {
      img: require('@/assets/wish/17.png'),
      id: 17
    },
    {
      img: require('@/assets/wish/18.png'),
      id: 18
    },
    {
      img: require('@/assets/wish/19.png'),
      id: 19
    },
    {
      img: require('@/assets/wish/20.png'),
      id: 20
    },
    {
      img: require('@/assets/wish/21.png'),
      id: 21
    },
    {
      img: require('@/assets/wish/22.png'),
      id: 22
    },
    {
      img: require('@/assets/wish/23.png'),
      id: 23
    },
    {
      img: require('@/assets/wish/24.png'),
      id: 24
    },
    {
      img: require('@/assets/wish/25.png'),
      id: 25
    },
    {
      img: require('@/assets/wish/26.png'),
      id: 26
    },
    {
      img: require('@/assets/wish/27.png'),
      id: 27
    },
    {
      img: require('@/assets/wish/28.png'),
      id: 28
    },
    {
      img: require('@/assets/wish/29.png'),
      id: 29
    },
    {
      img: require('@/assets/wish/30.png'),
      id: 30
    }
  ]
}